import moment from 'moment'
// Vite はロケールを自動では含めないため、日本語ロケールを明示的に読み込む。
// CJS 版の 'moment/locale/ja' は moment 本体が別インスタンスになり反映されないため、
// ESM 版の 'moment/dist/locale/ja' を指定する（これが無いと "a few seconds ago" のまま）
import 'moment/dist/locale/ja'
// import 'moment-timezone';

// set locale to japan
moment.locale('ja')
// moment.tz.setDefault("Asia/Tokyo");

export const getTimeAgo = (dateTime: any) => {
  const diffDays = moment().diff(dateTime, 'days')
  if (diffDays > 365) {
    return moment(dateTime).format('LLL')
  }

  return moment(dateTime).fromNow()
}

export const format = (dateTime: any, format: string) => {
  return moment(dateTime).format(format)
}

// YYYY/mm/dd HH:mm
export const formatDefaultDatetime = (dateTime: any) => {
  return format(dateTime, 'YYYY/MM/DD HH:mm')
}

// YYYY/mm/dd
export const formatDefaultDate = (date: any) => {
  return format(date, 'l')
}

export const now = () => {
  return moment()
}

// timestamp to HH:mm:ss
export const formatTimestamp = (timestamp: number) => {
  const hours = Math.floor(timestamp / 3600)
  const min = Math.floor((timestamp - hours * 3600) / 60)
  const sec = Math.floor(timestamp - hours * 3600 - min * 60)

  let displayTime = ''
  if (hours > 0) {
    displayTime += `${hours}:`
  }
  displayTime += `${('0' + min).slice(-2)}:${('0' + sec).slice(-2)}`
  return displayTime
}

export interface TimeUtils {
  format: typeof format
  formatDefaultDate: typeof formatDefaultDate
  formatDefaultDatetime: typeof formatDefaultDatetime
  getTimeAgo: typeof getTimeAgo
  now: typeof now
  formatTimestamp: typeof formatTimestamp
}

export const delay = (ms: number): Promise<void> => {
  return new Promise((resolve) => setTimeout(resolve, ms))
}
